import * as React from 'react';
import { useEffect } from 'react';
import useCollapse from 'react-collapsed';
import { UseCollapseOutput } from 'react-collapsed/dist/types';

import { ValidationBarTheme } from '../../enums';

import { Bar, BarInnerWrapper, UnderlineButton } from './validationBar.styled';
import { ValidationBarProps } from './validationBar.types';

export const ValidationBar: React.FC<ValidationBarProps> = (props: ValidationBarProps) => {
  const {
    message,
    barTheme = ValidationBarTheme.Error,
    buttonLabel,
    buttonData,
    renderButtonInline = false,
    className
  }: ValidationBarProps = props;
  const { getCollapseProps, setExpanded }: UseCollapseOutput = useCollapse({ isExpanded: !!message });

  useEffect((): void => setExpanded(!!message), [message]);

  return (
    <Bar $theme={barTheme} className={className} {...getCollapseProps()}>
      <BarInnerWrapper $renderButtonInline={renderButtonInline}>
        {message}
        {!!buttonLabel && (
          <UnderlineButton {...buttonData} $renderButtonInline={renderButtonInline}>
            {buttonLabel}
          </UnderlineButton>
        )}
      </BarInnerWrapper>
    </Bar>
  );
};
